import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import { useFormaliteService } from '@europrocurement/l2d-domain';
import React from 'react';

import { ReglementsEtAcomptesCBAcompteUpdate } from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { useToaster } from '@europrocurement/l2d-modules/hooks';
import { useForm } from 'react-hook-form';
import { Backdrop, Button, CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
import { CollectionProvisionType } from '../../../hooks/useCollectionProvision';

export type ProvisionUpdateType = {
    acompte: CollectionProvisionType;
    afterSubmit: () => void;
};

const ProvisionUpdate: React.FunctionComponent<ProvisionUpdateType> = function ({
    acompte,
    afterSubmit,
}) {
    const [isLoading, setIsLoading] = React.useState(false);

    const { acomptesApi } = useFormaliteService();

    const formStructure: FormStructure[] = React.useMemo(
        () => [
            {
                type: 'header',
                label: "Modifier l'encaissement",
                name: 'main_informations',
            },
            {
                type: 'date',
                name: 'date',
                inputlabel: 'Date',
                disableFuture: true,
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
            },
            {
                type: 'text',
                name: 'reference',
                inputlabel: 'Référence',
                placeholder: 'REF001',
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
            },
            {
                type: 'text',
                name: 'note',
                inputlabel: 'Note',
                placeholder: 'Note de la transaction',
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
            },
        ],
        [],
    );

    type ProvisionFormObject = {
        date?: Date;
        reference?: string;
        note?: string;
    };

    const provisionFormObject: Partial<ProvisionFormObject> = {
        date: new Date(acompte.dreception || ''),
        reference: acompte.reference || undefined,
        note: acompte.note || undefined,
    };

    const formContext = useForm({
        mode: 'onTouched',
        defaultValues: provisionFormObject,
    });

    const { handleApiResponse } = useToaster();

    const valueOrUndefined = (fieldToTest?: string | null): string | undefined =>
        fieldToTest !== undefined && fieldToTest !== null && fieldToTest !== ''
            ? (fieldToTest as unknown as string)
            : undefined;

    const onSubmit = async () => {
        setIsLoading(true);

        const reglementsEtAcomptesCBAcompteUpdate: ReglementsEtAcomptesCBAcompteUpdate = {
            dreception: valueOrUndefined(formContext.getValues().date as unknown as string),
            reference: valueOrUndefined(formContext.getValues().reference as unknown as string),
            note: valueOrUndefined(formContext.getValues().note as unknown as string),
        };

        const updateRequest = acomptesApi.apiAcomptesIdPatch({
            id: acompte.id as unknown as string,
            reglementsEtAcomptesCBAcompteUpdate,
        });

        await handleApiResponse(updateRequest, afterSubmit);
        setIsLoading(false);
    };

    const formProps = {
        formContext,
        onSubmit,
        formObject: {},
        submitButton: {
            displayed: false,
        },
    };

    return (
        <>
            <Backdrop
                sx={(backDropTheme) => ({ color: '#fff', zIndex: backDropTheme.zIndex.drawer + 1 })}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <FlexyForm
                {...formProps}
                formStructure={formStructure}
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'end',
                    alignItems: 'center',
                    gap: '32px',
                    marginTop: '10px',
                }}
            >
                <Button
                    variant="contained"
                    sx={{ backgroundColor: 'primary.dark', padding: '16px 24px' }}
                    onClick={onSubmit}
                >
                    Valider
                </Button>
            </Box>
        </>
    );
};

export default ProvisionUpdate;
